
import React from "react";
import { Shell } from "@/components/layout/Shell";
import { GroupForm, GroupFormValues } from "@/components/groups/GroupForm";
import { useGroups } from "@/hooks/useGroups";
import { useNavigate } from "react-router-dom";

export default function GroupCreatePage() {
  const navigate = useNavigate();
  const { useCreateGroupMutation } = useGroups();
  const createGroupMutation = useCreateGroupMutation();

  const handleSubmit = (values: GroupFormValues) => {
    createGroupMutation.mutate(
      {
        name: values.name,
        description: values.description,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      {
        onSuccess: () => {
          navigate("/groups");
        },
      }
    );
  };

  return (
    <Shell className="p-4 md:p-6">
      <h1 className="text-3xl font-bold tracking-tight mb-6">Create Group</h1>
      <GroupForm 
        onSubmit={handleSubmit} 
        isLoading={createGroupMutation.isPending}
        mode="create"
      />
    </Shell>
  );
}
